
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"21.5","height":"17.5"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_44319","data-name":"Group 44319","transform":"translate(.344 .344)"}},[_c('g',{attrs:{"id":"Group_42835","data-name":"Group 42835","transform":"translate(.406 .406)","fill":"none","stroke":"#262626","stroke-width":"1.5"}},[_c('path',{attrs:{"id":"Path_29271","data-name":"Path 29271","d":"M19.8 8.864H1.7a.93.93 0 00-.946.913v10.4a.93.93 0 00.946.913h18.1a.93.93 0 00.946-.913v-10.4a.93.93 0 00-.946-.913z","transform":"translate(-.75 -5.091)"}}),_c('path',{attrs:{"id":"Path_29272","data-name":"Path 29272","d":"M10.558.75H6.737a.928.928 0 00-.928.928v2.845h5.678V1.678a.928.928 0 00-.929-.928z","transform":"translate(-3.457 -.75)"}}),_c('path',{attrs:{"id":"Path_29273","data-name":"Path 29273","d":"M30.414.75h-3.821a.928.928 0 00-.928.928v2.845h5.678V1.678a.928.928 0 00-.929-.928z","transform":"translate(-13.695 -.75)"}})])])])
          )
        }
      }
    